
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.688 3h.406C16.71 3 18.002 4.23 18 5.656c0 1.336-.468 2.327-.938 2.969-.294.401-.422.469-.625.625l-.188.75h10.75c1.645 0 3 1.355 3 3s-1.355 3-3 3h-3.563l-1.656 7.625A3.019 3.019 0 0118.842 26H1.998V10h5.594l6.781-6.719zm.718 2.094L9 11.407v12.594h9.844c.477 0 .9-.314 1-.781l1.781-8.438.188-.781h5.188c.565 0 1-.435 1-1s-.435-1-1-1H13.657l.313-1.25.594-2.25.125-.406.344-.188s.179-.084.438-.438.531-.91.531-1.813c0-.308-.172-.481-.594-.563zM4 12v12h3V12H4z"}})])
          )
        }
      }
    